import { useEffect, useState } from "react";
import { motion } from "framer-motion";

const bootMessages = [
  { text: ">>> Initializing Neural Interface...", color: "text-green-400" },
  { text: ">>> Connecting to GitHub...", color: "text-cyan-400" },
  { text: ">>> Loading Portfolio Assets...", color: "text-green-400" },
  { text: ">>> Decrypting user profile...", color: "text-cyan-400" },
  { text: ">>> The Construct is ready.", color: "text-green-300" },
];

const AsciiIntro = ({ onFinish }) => {
  const [currentLine, setCurrentLine] = useState(0);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const cursorBlink = setInterval(() => setShowCursor((p) => !p), 500);
    const lineInterval = setInterval(() => {
      setCurrentLine((prev) => {
        if (prev === bootMessages.length - 1) {
          clearInterval(lineInterval);
          if (onFinish) setTimeout(onFinish, 1500);
        }
        return prev + 1;
      });
    }, 850);
    return () => { clearInterval(cursorBlink); clearInterval(lineInterval); };
  }, [onFinish]);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="fixed inset-0 z-50 flex flex-col items-center justify-center"
      style={{ background: "#050a0e" }}
    >
      {/* Scanline */}
      <div className="scanline-overlay" />

      <div className="relative z-10 w-full max-w-lg px-8">
        {/* Terminal chrome */}
        <div
          className="rounded-xl overflow-hidden"
          style={{ background: "rgba(8,18,32,0.9)", border: "1px solid rgba(0,255,153,0.2)", boxShadow: "0 0 60px rgba(0,255,153,0.08)" }}
        >
          <div
            className="flex items-center gap-2 px-4 py-2.5"
            style={{ borderBottom: "1px solid rgba(0,255,153,0.1)", background: "rgba(0,0,0,0.4)" }}
          >
            <div className="w-3 h-3 rounded-full bg-red-500/60" />
            <div className="w-3 h-3 rounded-full bg-yellow-500/60" />
            <div className="w-3 h-3 rounded-full bg-green-500/60" />
            <span className="ml-3 text-xs text-green-500/40 tracking-widest font-mono">construct.sh</span>
          </div>

          <div className="p-6 min-h-40">
            {bootMessages.slice(0, currentLine + 1).map((msg, idx) => (
              <motion.div
                key={idx}
                initial={{ opacity: 0, x: -10 }}
                animate={{ opacity: idx < currentLine ? 0.5 : 1, x: 0 }}
                className={`text-sm font-mono mb-2 tracking-wide ${msg.color}`}
              >
                {msg.text}
                {idx === currentLine && showCursor && (
                  <span className="ml-1">▊</span>
                )}
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AsciiIntro;
